import { Component, Fragment } from "react";
import { RouteComponentProps } from "react-router-dom";

import { ProviderNetworkType } from "@app/projects/enumerators";
import { CountyProjectContextProps, withCountyProjectContext } from "@app/projects/CountyProjectContext";
import { AccessSummary } from "@app/projects/results/adequacy";
import { ImpactProvidersPanel, NetworkProvidersPanel } from "@app/projects/servicing-provider";
import { ViewableFieldsContainer } from "@app/viewable-fields";

interface ProjectProps {
  accessSummary: AccessSummary;
  regionSetId: number;
  specialtyGroupCode: string;
}

type DetailsProps = RouteComponentProps<unknown> & ProjectProps & CountyProjectContextProps;

class Details extends Component<DetailsProps> {
  constructor(props: DetailsProps) {
    super(props);
  }

  public render() {
    const haveResultsToRender = !!this.props.runConfiguration && !!this.props.adequacyResult && !!this.props.adequacyResult.details;

    return (
      <Fragment>
        {(haveResultsToRender) &&
          this.renderResults()
        }
      </Fragment>
    );
  }

  private renderResults = () => {
    const exportEndpoint = `${this.props.match.url}/export/${this.props.runConfiguration.projectRunConfigurationId}/${this.props.runConfiguration.isLatestPublished}`;

    if (!this.props.project || !this.props.accessSummary) {
      return null;
    }

    return (
      <ViewableFieldsContainer projectRunConfigurationId={this.props.runConfiguration.projectRunConfigurationId} customProjectId={this.props.project.projectId} specialtyGroupCode={this.props.specialtyGroupCode}>
        <NetworkProvidersPanel {...this.props} accessSummary={this.props.accessSummary} className="mt20" exportEndpoint={exportEndpoint} projectURL={this.props.location.pathname} nextClosestProviders={false} regionSetId={this.props.regionSetId} specialtyGroupCode={this.props.specialtyGroupCode} />
        {
          this.props.runConfiguration.prospectProviderSetId && this.props.runConfiguration.prospectProviderSetVersionId &&
          <ImpactProvidersPanel providerNetworkType={ProviderNetworkType.Prospect} {...this.props} accessSummary={this.props.accessSummary} exportEndpoint={exportEndpoint} projectURL={this.props.location.pathname} regionSetId={this.props.regionSetId} specialtyGroupCode={this.props.specialtyGroupCode} />
        }
        {
          this.props.runConfiguration.useMarketProvidersForImpact &&
          <ImpactProvidersPanel providerNetworkType={ProviderNetworkType.Market} {...this.props} accessSummary={this.props.accessSummary} exportEndpoint={exportEndpoint} projectURL={this.props.location.pathname} regionSetId={this.props.regionSetId} specialtyGroupCode={this.props.specialtyGroupCode} />
        }
      </ViewableFieldsContainer>
    );
  }
}

const WrappedDetails = withCountyProjectContext(Details);

export { WrappedDetails as Details };
